import { displayDate, getChatbotStatus } from '~/plugins/functions/display';

// For DTO PresetAssociation
export interface IModelGETPresetAssociationPresetResponse {
  id: string;
  name: string;
  description: string;
  safetyRule: string;
  modelName: string;
  tools: any;
  knowledgeBase: any;
  commandDetail: string;
  beginningMessage: string;
  toolSearchWeb: boolean;
  toolCanvas: boolean;
  toolDallEImage: boolean;
  toolCode: boolean;
  toolCodeText: any;
  versionCount: string;
  avatarFilePath: string;
  dbType: any;
  dbHost: any;
  dbPort: any;
  dbUsername: any;
  dbPassword: any;
  dbName: any;
  dbSchema: any;
  status: string;
  versionInUse: boolean;
  versionIsLatest: boolean;
  versionKey: string;
  isDuplicatedForUpdate: boolean;
  duplicatedFromId: any;
  duplicatedPendingId: any;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;
  softDeleted: boolean;
  files: IModelGETPresetAssociationPresetFilesResponse[];
  beginningMessages: IModelGETPresetAssociationPresetBeginningMessagesResponse[];
  links: IModelGETPresetAssociationPresetLinksResponse[];
  databases: IModelGETPresetAssociationPresetDatabasesResponse[];
  topKResult: number | null;
  documentChunkSize: number | null;
  documentChunkOverlap: number | null;
  vectorStoreType: string | null;
  recursionLimit: number | null;
  embeddingModelName: string | null;
  isExternal: boolean;
  assignmentType: string;
  departments: any[];
  users: any[];
  workflowType: string;
  workflowCondition: string;
}

export interface IModelGETPresetAssociationPresetFilesResponse {
  id: string;
  presetId: string;
  fileName: string;
  filePath: string;
  fileSize: string;
  mimeType: string;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;
  uploadedAt: string | Date;
  softDeleted: boolean;
}

export interface IModelGETPresetAssociationPresetBeginningMessagesResponse {
  id: string;
  presetId: string;
  message: string;
  promptLibraryId: number | null;
  promptLibrary: IModelPromptLibraryResponse;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;
  softDeleted: boolean;
}

export interface IModelGETPresetAssociationPresetLinksResponse {
  id: string;
  presetId: string;
  link: string;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;
  softDeleted: boolean;
}

export interface IModelPromptLibraryResponse {
  id: number;
  name: string;
  promptStarter: string;
  description: string;
}

export interface IModelGETPresetAssociationPresetDatabasesResponse {
  id: string;
  presetId: string;
  dbId: string;
  dbType: string;
  dbHost: string;
  dbPort: string;
  dbUsername: string;
  dbPassword: string;
  dbName: string;
  dbSchema: string;
  createdAt: string | Date;
  createdBy: string | null;
  updatedAt: string | Date;
  updatedBy: string | null;
  softDeleted: boolean;
  isCollapsed: boolean;
}

export class ModelGETPresetAssociationPresetBeginningMessages {
  id: string;
  presetId: string;
  message: string;
  description: string;
  promptLibraryId: number | null;
  promptLibrary: IModelPromptLibraryResponse;
  createdAt: string | Date;
  createdBy: any | null;
  updatedAt: string | Date;
  updatedBy: any | null;
  softDeleted: boolean;

  constructor(
    props = {} as IModelGETPresetAssociationPresetBeginningMessagesResponse
  ) {
    props =
      props ??
      ({} as IModelGETPresetAssociationPresetBeginningMessagesResponse);
    this.id = props.id || '';
    this.presetId = props.presetId || '';
    this.message = props.message || '';
    this.promptLibraryId = props.promptLibraryId || null;
    this.promptLibrary = props.promptLibrary;
    this.description = props.promptLibrary?.description || '';
    this.createdAt = props.createdAt || '';
    this.createdBy = props.createdBy || null;
    this.updatedAt = props.updatedAt || '';
    this.updatedBy = props.updatedBy || null;
    this.softDeleted = props.softDeleted || false;
  }
}

export class ModelGETPresetAssociationPresetLinks {
  id: string;
  presetId: string;
  link: string;
  createdAt: string | Date;
  createdBy: any | null;
  updatedAt: string | Date;
  updatedBy: any | null;
  softDeleted: boolean;

  constructor(props = {} as IModelGETPresetAssociationPresetLinksResponse) {
    props = props ?? ({} as IModelGETPresetAssociationPresetLinksResponse);
    this.id = props.id || '';
    this.presetId = props.presetId || '';
    this.link = props.link || '';
    this.createdAt = props.createdAt || '';
    this.createdBy = props.createdBy || null;
    this.updatedAt = props.updatedAt || '';
    this.updatedBy = props.updatedBy || null;
    this.softDeleted = props.softDeleted || false;
  }
}

export class ModelGETPresetAssociationPresetFiles {
  id: string;
  presetId: string;
  fileName: string;
  filePath: string;
  fileSize: string;
  mimeType: string;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  uploadedAt: string | Date;
  updatedBy: any;
  softDeleted: boolean;

  name: string;
  file: Blob | null;
  url: string;
  displayDateUploadedAt: string;

  constructor(props = {} as IModelGETPresetAssociationPresetFilesResponse) {
    props = props ?? ({} as IModelGETPresetAssociationPresetFilesResponse);
    this.id = props.id || '';
    this.presetId = props.presetId || '';
    this.fileName = props.fileName || '';
    this.filePath = props.filePath || '';
    this.fileSize = props.fileSize || '';
    this.mimeType = props.mimeType || '';
    this.createdAt = props.createdAt || '';
    this.createdBy = props.createdBy || null;
    this.updatedAt = props.updatedAt || '';
    this.uploadedAt = props.uploadedAt || '';
    this.updatedBy = props.updatedBy || null;
    this.softDeleted = props.softDeleted || false;

    this.name = this.fileName;
    this.file = null;
    this.url = this.filePath;
    this.displayDateUploadedAt = displayDate(this.uploadedAt, { isTime: true });
  }
}

export class ModelGETPresetAssociationPresetDatabases {
  id: string;
  presetId: string;
  dbId: string;
  dbType: string;
  dbHost: string;
  dbPort: string;
  dbUsername: string;
  dbPassword: string;
  dbName: string;
  dbSchema: string;
  createdAt: string | Date;
  createdBy: string | null;
  updatedAt: string | Date;
  updatedBy: string | null;
  softDeleted: boolean;
  isCollapsed: boolean;

  constructor(props = {} as IModelGETPresetAssociationPresetDatabasesResponse) {
    props = props ?? ({} as IModelGETPresetAssociationPresetDatabasesResponse);
    this.id = props.id || '';
    this.presetId = props.presetId || '';
    this.dbId = props.dbId || '';
    this.dbType = props.dbType || '';
    this.dbHost = props.dbHost || '';
    this.dbPort = props.dbPort || '';
    this.dbUsername = props.dbUsername || '';
    this.dbPassword = props.dbPassword || '';
    this.dbName = props.dbName || '';
    this.dbSchema = props.dbSchema || '';
    this.createdAt = props.createdAt || '';
    this.createdBy = props.createdBy || null;
    this.updatedAt = props.updatedAt || '';
    this.updatedBy = props.updatedBy || null;
    this.softDeleted = props.softDeleted || false;
    this.isCollapsed = false;
  }
}

export class ModelGETPresetAssociationPreset {
  id: string;
  name: string;
  description: string;
  safetyRule: string;
  modelName: string;
  tools: any;
  knowledgeBase: any;
  commandDetail: string;
  beginningMessage: string;
  toolSearchWeb: boolean;
  toolCanvas: boolean;
  toolDallEImage: boolean;
  toolCode: boolean;
  toolCodeText: any;
  versionCount: string;
  avatarFilePath: string;
  dbType: any;
  dbHost: any;
  dbPort: any;
  dbUsername: any;
  dbPassword: any;
  dbName: any;
  dbSchema: any;
  status: string;
  versionInUse: boolean;
  versionIsLatest: boolean;
  versionKey: string;
  isDuplicatedForUpdate: boolean;
  duplicatedFromId: any;
  duplicatedPendingId: any;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;
  softDeleted: boolean;
  filesList: ModelGETPresetAssociationPresetFiles[];
  beginningMessagesList: ModelGETPresetAssociationPresetBeginningMessages[];
  linksList: ModelGETPresetAssociationPresetLinks[];
  databasesList: ModelGETPresetAssociationPresetDatabases[];
  sharePointList: any[];
  mapSharePointList: any[];
  sharePointSelectedList: any[];
  topKResult: number | null;
  documentChunkSize: number | null;
  documentChunkOverlap: number | null;
  vectorStoreType: string | null;
  recursionLimit: number | null;
  embeddingModelName: string | null;

  isExternal: boolean;

  avatarFile: any;
  displayCreatedAt: string;
  displayUpdatedAt: string;
  displayStatus: string;

  promptLibrarySelectedList: any[];

  assignmentType: string;
  departments: any[];
  users: any[];
  departmentSelectedList: any[];
  userSelectedList: any[];
  mapDepartmentList: any[];
  mapUserList: any[];
  workflowType: string;
  workflowCondition: string;

  constructor(props = {} as IModelGETPresetAssociationPresetResponse) {
    props = props ?? ({} as IModelGETPresetAssociationPresetResponse);
    this.id = props.id || '';
    this.name = props.name || '';
    this.description = props.description || '';
    this.safetyRule = props.safetyRule || '';
    this.modelName = props.modelName || '';
    this.tools = props.tools || null;
    this.knowledgeBase = props.knowledgeBase || null;
    this.commandDetail = props.commandDetail || '';
    this.beginningMessage = props.beginningMessage || '';
    this.toolSearchWeb = props.toolSearchWeb || false;
    this.toolCanvas = props.toolCanvas || false;
    this.toolDallEImage = props.toolDallEImage || false;
    this.toolCode = props.toolCode || false;
    this.toolCodeText = props.toolCodeText || null;
    this.versionCount = props.versionCount || '';
    this.avatarFilePath = props.avatarFilePath || '';
    this.dbType = props.dbType || '';
    this.dbHost = props.dbHost || '';
    this.dbPort = props.dbPort || '';
    this.dbUsername = props.dbUsername || '';
    this.dbPassword = props.dbPassword || '';
    this.dbName = props.dbName || '';
    this.dbSchema = props.dbSchema || '';
    this.status = props.status || '';
    this.versionInUse = props.versionInUse || false;
    this.versionIsLatest = props.versionIsLatest || false;
    this.versionKey = props.versionKey || '';
    this.isDuplicatedForUpdate = props.isDuplicatedForUpdate || false;
    this.duplicatedFromId = props.duplicatedFromId || null;
    this.duplicatedPendingId = props.duplicatedPendingId || null;
    this.createdAt = props.createdAt || '';
    this.createdBy = props.createdBy || null;
    this.updatedAt = props.updatedAt || '';
    this.updatedBy = props.updatedBy || null;
    this.softDeleted = props.softDeleted || false;
    this.filesList = (props.files || []).map(
      (e) => new ModelGETPresetAssociationPresetFiles(e)
    );
    this.beginningMessagesList = (props.beginningMessages || []).map(
      (e) => new ModelGETPresetAssociationPresetBeginningMessages(e)
    );
    this.linksList = (props.links || []).map(
      (e) => new ModelGETPresetAssociationPresetLinks(e)
    );
    this.databasesList = (props.databases || []).map(
      (e: IModelGETPresetAssociationPresetDatabasesResponse) =>
        new ModelGETPresetAssociationPresetDatabases(e)
    );
    this.sharePointList = [];
    this.mapSharePointList = [];
    this.sharePointSelectedList = [];
    this.promptLibrarySelectedList = props.beginningMessages
      ? props.beginningMessages
          .map((bm) => bm.promptLibraryId)
          .filter((id) => id != null)
      : [];
    this.topKResult = props.topKResult || null;
    this.documentChunkSize = props.documentChunkSize || null;
    this.documentChunkOverlap = props.documentChunkOverlap || null;
    this.vectorStoreType = props.vectorStoreType || null;
    this.recursionLimit = props.recursionLimit || null;
    this.embeddingModelName = props.embeddingModelName || null;

    this.isExternal = props.isExternal || false;

    this.avatarFile = this.avatarFilePath
      ? {
          url: this.avatarFilePath,
        }
      : undefined;
    this.displayCreatedAt = displayDate(this.createdAt, {
      isTime: true,
    });
    this.displayUpdatedAt = displayDate(this.updatedAt, {
      isTime: true,
    });
    this.displayStatus = getChatbotStatus(this.status);

    this.assignmentType = props.assignmentType || '';
    this.departments = props.departments || [];
    this.users = props.users
      ? props.users.map((e) => {
          return { ...e, email: e.user?.email || '' };
        })
      : [];
    this.departmentSelectedList = props.departments || [];
    this.userSelectedList = props.users
      ? props.users.map((e) => {
          return { ...e, email: e.user?.email || '' };
        })
      : [];
    this.mapDepartmentList = [];
    this.mapUserList = [];

    this.workflowType = props.workflowType || '';
    this.workflowCondition = props.workflowCondition || '';
  }
}

export interface IModelPresetActiveResponse {
  id: number;
  name: string;
  preset: {
    name: string;
  };
  presetId: string;
}

export class ModelPresetActive {
  id: number;
  name: string;
  presetId: string;

  constructor(props = {} as IModelPresetActiveResponse) {
    this.id = props.id;
    this.name = props.preset ? props.preset.name : '';
    this.presetId = props.presetId || '';
  }
}

export interface IModelSiteResponse {
  isToggle: boolean;
  id: number;
  name: string;
}

export class ModelSite {
  isToggle: boolean;
  id: number;
  name: string;

  constructor(props = {} as IModelSiteResponse) {
    props = props ?? {};
    this.isToggle = false;
    this.id = props.id;
    this.name = props.name;
  }
}

export interface IModelDriveResponse {
  isToggle: boolean;
  id: number;
  name: string;
}

export class ModelDrive {
  isToggle: boolean;
  id: number;
  name: string;

  constructor(props = {} as IModelDriveResponse) {
    props = props ?? {};
    this.isToggle = false;
    this.id = props.id;
    this.name = props.name;
  }
}

export interface IModelDriveItemResponse {
  id: number;
  name: string;
  type: string;
  folder?: any;
}

export class ModelDriveItem {
  id: number;
  name: string;
  type: string;

  constructor(props = {} as IModelDriveItemResponse) {
    props = props ?? {};
    this.id = props.id;
    this.name = props.name;
    this.type = props.folder ? 'folder' : 'file';
  }
}

export interface IModelSharePointResponse {
  id: number;
  presetId: string;
  siteId: string;
  siteName: string;
  driveId: string;
  driveName: string;
  itemId: string;
  itemName: string;
  status: string;
}

export class ModelSharePoint {
  id: number;
  presetId: string;
  siteId: string;
  siteName: string;
  driveId: string;
  driveName: string;
  itemId: string;
  itemName: string;
  status: string;

  constructor(props = {} as IModelSharePointResponse) {
    props = props ?? {};
    this.id = props.id;
    this.presetId = props.presetId;
    this.siteId = props.siteId;
    this.siteName = props.siteName;
    this.driveId = props.driveId;
    this.driveName = props.driveName;
    this.itemId = props.itemId;
    this.itemName = props.itemName;
    this.status = props.status;
  }
}

export interface IModelSharePointIndexingResponse {
  id: string;
  type: string;
  status: string;
  totalFiles: string;
  processedFiles: string;
  failedFiles: string;
  completedAt: string;
  failedAt: string;
  errorMessage: string;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
  softDeleted: boolean;
}

export class ModelSharePointIndexing {
  id: string;
  type: string;
  status: string;
  totalFiles: string;
  processedFiles: string;
  failedFiles: string;
  completedAt: string;
  failedAt: string;
  errorMessage: string;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
  softDeleted: boolean;

  constructor(props = {} as IModelSharePointIndexingResponse) {
    props = props ?? {};
    this.id = props.id;
    this.type = props.type;
    this.status = props.status;
    this.totalFiles = props.totalFiles;
    this.processedFiles = props.processedFiles;
    this.failedFiles = props.failedFiles;
    this.completedAt = props.completedAt;
    this.failedAt = props.failedAt;
    this.errorMessage = props.errorMessage;
    this.createdAt = props.createdAt;
    this.createdBy = props.createdBy;
    this.updatedAt = props.updatedAt;
    this.updatedBy = props.updatedBy;
    this.softDeleted = props.softDeleted;
  }
}

export interface IModelDepartmentResponse {
  id: number;
  department: string;
  subDepartment: string;
  functionCode: string;
}

export class ModelDepartment {
  id: number;
  department: string;
  subDepartment: string;
  functionCode: string;

  constructor(props = {} as IModelDepartmentResponse) {
    props = props ?? {};
    this.id = props.id;
    this.department = props.department;
    this.subDepartment = props.subDepartment;
    this.functionCode = props.functionCode;
  }
}

export interface IModelUserResponse {
  id: number;
  adminConsoleId: number;
  username: string;
  email: string;
  phone: string | null;
  status: 'enable' | 'disable';
  avatar: string | null;

  originAppId: number;
  inputToken: string;
  outputToken: string;

  department: string;
  role: string;

  lastLoginAt: string | null;
  lastActiveAt: string | null;

  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;

  adminType: string | null;
  departmentMapping?: IModelDepartmentResponse | null;
}

export class ModelUser {
  userId: number;
  // username: string;
  email: string;
  department: string;
  subDepartment: string;
  functionCode: string;
  // departmentMapping: ModelDepartment | null;

  constructor(props = {} as IModelUserResponse) {
    props = props ?? {};
    this.userId = props.id;
    // this.username = props.username;
    this.email = props.email;
    this.department = props.departmentMapping?.department || '';
    this.subDepartment = props.departmentMapping?.subDepartment || '';
    this.functionCode = props.departmentMapping?.functionCode || '';
    // this.departmentMapping = props.departmentMapping
    //   ? new ModelDepartment(props.departmentMapping)
    //   : null;
  }
}
